import classNames from 'classnames';
import PropTypes from 'prop-types';
import Dotdotdot from 'react-dotdotdot';
import styled, { css } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import style from './index.module.scss';

const Fund = ({ fund, isSelected, isHighlighted, onClick }) => (
  <div
    onClick={() => onClick(fund)}
    className="grid__item one-third palm--one-whole"
  >
    <FundWrapper $isHighlighted={isHighlighted} $isSelected={isSelected}>
      <div className="flex flex-center space-between">
        <FundTitle
          $isSelected={isSelected}
          $isHighlighted={isHighlighted}
          data-testid={fund.title}
        >
          {fund.is_fallback
            ? __('Type in your own designation...')
            : fund.title}
        </FundTitle>
        <div
          className={classNames(
            'flex flex-center flex--justify-center',
            style.checkbox,
            {
              'custom-border-color-button-primary custom-border-color-login-button':
                isSelected,
              [style['checkbox--selected']]: isSelected,
            },
          )}
        >
          {isSelected && (
            <i
              className={`icon-check ${style.checkbox__icon}`}
              data-testid="checkbox-selected"
            />
          )}
        </div>
      </div>
      {isHighlighted && (
        <Dotdotdot clamp={4}>
          <Box
            display="block"
            font="metadata-regular-dove"
            mt={3}
            color={isSelected && 'white'}
          >
            {fund.description}
          </Box>
        </Dotdotdot>
      )}
    </FundWrapper>
  </div>
);

Fund.propTypes = {
  fund: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  isHighlighted: PropTypes.bool,
};

export default Fund;

const FundWrapper = styled(Box).attrs(({ $isSelected }) => ({
  bg: $isSelected ? 'primary' : 'smoke',
  display: 'block',
  font: 'body-semibold-asphalt',
}))`
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 14px;
  padding: 11px 18px;

  ${({ $isSelected }) =>
    $isSelected &&
    css`
      box-shadow: 2px 4px 5px rgba(0, 0, 0, 0.15);
    `}

  ${({ $isHighlighted }) =>
    $isHighlighted &&
    css`
      padding: 14px 18px;
      height: 118px;
    `}
`;

const FundTitle = styled(Box).attrs(({ $isSelected }) => ({
  font: 'body-semibold-asphalt',
  color: $isSelected && 'white',
}))`
  ${({ $isHighlighted }) =>
    $isHighlighted &&
    css`
      letter-spacing: 0.3px;
      font-size: 15px;
    `}
`;
